// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

type AddressState = {
    activeShipTo?: ShipToModel;
};

const initialState: AddressState = {
    activeShipTo: undefined,
};

const reducer = {
    "xAddresses/SetActiveShipTo": (draft: Draft<AddressState>, action: { shipTo: ShipToModel }) => {
        draft.activeShipTo = action.shipTo;
    },
};

const xAddresses = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xAddresses = xAddresses;

export type xAddressesState = {
    xAddresses: AddressState;
} & ApplicationState;
